import React, { useState } from 'react';
import cx from 'classnames';

const PocLayoutGrid = () => {
  const [showLayoutGrid, setShowLayoutGrid] = useState(true);
  const toggleHandler = (e) => {
    e.preventDefault();
    setShowLayoutGrid(!showLayoutGrid);
  };
  return (
    <>
      {/**
       * This is not a grid implementation. It is only meant to help visualize the existing grid.
       * CSS-in-JS used here merely for convenience in POC of this MVP component.
       * ... though can be considered another example use case to make the argument for CSS-in-JS :)
       */}
      <style jsx>{`
        .poc-layout {
          position: fixed;
          top: 0;
          width: 100%;
          min-height: 100vh;
          z-index: 1;
          pointer-events: none;
        }
        .poc-layout__grid--is-hidden {
          display: none;
        }
        .poc-grid-container,
        .poc-grid {
          height: 100vh;
        }
        .poc-grid__cell {
          background: rgba(216, 216, 216, 0.18);
          text-align: center;
          outline: inset 1px black;
        }
        .poc-layout__toggle {
          position: fixed;
          bottom: 10rem;
          right: 1rem;
          z-index: 1;
          border: 1px solid;
          border-radius: 5px;
          padding: 0.5rem;
          background: #e1ecf4;
          color: #222;
          font-size: 16px;
          pointer-events: all;
          user-select: none;
        }
        .poc-layout__toggle:hover {
          background: #96bdd9;
          color: #111;
        }
      `}</style>
      <div className='poc-layout'>
        <button className='poc-layout__toggle' onClick={toggleHandler}>
          Toggle Layout Grid
        </button>
        <div
          className={cx('poc-layout__grid', {
            'poc-layout__grid--is-hidden': !showLayoutGrid,
          })}
        >
          <div className={cx('grid-container', 'poc-grid-container')}>
            <div className={cx('grid-x small-margin-collapse', 'poc-grid')}>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
              <div className={cx('cell', 'small-1', 'poc-grid__cell')}></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PocLayoutGrid;
